import { PaymentEventItem } from '../services/useBenefitService';

export const calculateMaxRewardUsage = (reward_amount: number, total_amount: number) => {
  const max_reward = Math.floor(reward_amount / 10) * 10;
  return total_amount < max_reward ? total_amount : max_reward;
};

export const calculateMaxMileageUsage = (
  max_allowed_mileage: number,
  available_mileage: number,
  total_amount: number,
) => {
  const applicable_mileage = Math.min(max_allowed_mileage, total_amount);
  const max_mileage = applicable_mileage < available_mileage ? applicable_mileage : available_mileage;
  return Math.floor(max_mileage / 10) * 10;
};

export const applyRewardDiscount = (reward_amount: number, total_amount: number) => {
  const discount = calculateMaxRewardUsage(reward_amount, total_amount);
  return total_amount - discount;
};

export const applyPaymentEventDiscount = (
  payment_events: PaymentEventItem[],
  total_amount: number,
  event_id: number,
) => {
  const discount_amount = payment_events.find((event) => event.id === event_id)?.discount_amount ?? 0;
  return total_amount - discount_amount;
};
